/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const HANDLE_ERROR_MESSAGE_UPG = 'HANDLE_ERROR_MESSAGE_UPG';
export const UPDATE_PARAM_GENERAL_SCREEN_TAB_DATA =
  'UPDATE_PARAM_GENERAL_SCREEN_TAB_DATA';
export const SAVE_OR_UPDATE_UPG = 'SAVE_OR_UPDATE_UPG';
export const GET_REMINDER_RECIPIENT_LIST = 'GET_REMINDER_RECIPIENT_LIST';
export const GET_GENERAL_SYSTEM_PARAMETER_UPG='GET_GENERAL_SYSTEM_PARAMETER_UPG'
